import React from 'react';
import * as Styled from './ProductSummary.styles';

var BuildCareItem = function BuildCareItem(_ref) {
  var itemDetails = _ref.itemDetails,
      dataTest = _ref.dataTest,
      isMonthly = _ref.isMonthly;
  return /*#__PURE__*/React.createElement(Styled.ProductListItem, null, /*#__PURE__*/React.createElement(Styled.ProductThumbnailContainer, {
    "data-test": "".concat(dataTest, "-image")
  }, itemDetails.hostProduct ? /*#__PURE__*/React.createElement(Styled.ProductThumbnailImage, {
    src: "//media.4rgos.it/s/Argos/".concat(itemDetails.partNumber, "_R_SET?w=80&h=80"),
    alt: itemDetails.productName
  }) : /*#__PURE__*/React.createElement(Styled.ProductThumbnailSVG, {
    height: "48px",
    width: "48px"
  })), /*#__PURE__*/React.createElement(Styled.ProductTitle, {
    "data-test": "".concat(dataTest, "-label")
  }, itemDetails.quantity > 1 ? "".concat(itemDetails.quantity, " x ").concat(itemDetails.productName) : itemDetails.productName, isMonthly && /*#__PURE__*/React.createElement("p", null, "You can set up Monthly Care on the page confirming your order.")), /*#__PURE__*/React.createElement(Styled.ProductPrice, {
    "data-test": "".concat(dataTest, "-price")
  }, /*#__PURE__*/React.createElement("span", null, itemDetails.hostProduct ? "\xA3".concat(itemDetails.productPrice) : "+\xA3".concat(itemDetails.productPrice)), isMonthly && /*#__PURE__*/React.createElement(Styled.Each, null, "per month"), itemDetails.quantity > 1 && /*#__PURE__*/React.createElement(Styled.Each, null, isMonthly ? 'per item' : 'each')));
};

var TotalPrice = function TotalPrice(_ref2) {
  var totalPrice = _ref2.totalPrice,
      _ref2$text = _ref2.text,
      text = _ref2$text === void 0 ? 'Total for all items' : _ref2$text;
  if (!totalPrice) return null;
  return /*#__PURE__*/React.createElement(Styled.TotalPriceContainer, null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("strong", null, text)), /*#__PURE__*/React.createElement(Styled.TotalPrice, null, "\xA3", totalPrice.toFixed(2)));
};

var ProductSummary = function ProductSummary(_ref3) {
  var hostDetails = _ref3.hostDetails,
      warrantyDetails = _ref3.warrantyDetails,
      totalPrice = _ref3.totalPrice,
      displayProductSummary = _ref3.displayProductSummary,
      onlyWarranty = _ref3.onlyWarranty,
      isMonthly = _ref3.isMonthly,
      dataTest = _ref3.dataTest;
  if (!displayProductSummary) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Styled.ProductSummaryListContainer, null, !onlyWarranty && /*#__PURE__*/React.createElement(BuildCareItem, {
    itemDetails: hostDetails,
    dataTest: dataTest
  }), /*#__PURE__*/React.createElement(BuildCareItem, {
    itemDetails: warrantyDetails,
    dataTest: dataTest,
    isMonthly: isMonthly
  })), !onlyWarranty && /*#__PURE__*/React.createElement(TotalPrice, {
    totalPrice: totalPrice
  }));
};

export default ProductSummary;